import { defineStore } from "pinia";
import { type AcceptedDto } from "../dto/file.dto";
import { useFileApi } from "../http/file.api";

export interface FileStoreState {
  accepted: AcceptedDto;
}
export const useFileStore = defineStore("file", {
  state: (): FileStoreState => {
    return { accepted: { extensions: [], mimeTypes: [] } };
  },
  actions: {
    setAccepted(accepted: AcceptedDto) {
      this.accepted = accepted;
    },
    async getAccepted() {
      const result = await useFileApi().getAccepted();
      this.accepted = {
        extensions: result.extensions,
        mimeTypes: result.mimeTypes,
      };
    },
    async createLink(object: string) {
      return useFileApi().createLink(object);
    },
    async getLink(token: string, asAttachment: boolean = false) {
      return useFileApi().getLink(token, asAttachment);
    },
  },
});
